import React, { FC, useState } from "react"
import { makeStyles, Dialog, DialogContent, DialogContentText, DialogTitle, ListItemIcon, IconButton, ListItemText, ListItem, SvgIcon, ListSubheader, List } from "@material-ui/core"

import CompareArrowsIcon from '@material-ui/icons/CompareArrows';

const useStyles = makeStyles(theme => ({

  listItems: {
    maxHeight: "400px",
  },
}))

  interface Props { // will be used for future prop implementations
  }

  const helpText = () => { // The current shortcuts implemented, the var is used to display a list to the user.
    let listOfActions =
  " Alt + Shift + M : Gå til Mobilbase: \n" +
  " Alt + Shift + B : Gå til Brugere: \n"  +
  " Alt + Shift + P : Gå til Pladsadgang: \n" +
  " Alt + Shift + S : Gå til Statistik page: \n"+
  "\t Shift + S + K : Gå til Kreditkort i Statistik: \n"+
  "\t Shift + S + P : Gå til Posteringsoversigt i Statistik: \n" +
  "\t Shift + S + M : Gå til Mønttømninger i Statistik: \n" +
  "\t Shift + S + A : Gå til Alarmer and Hændelser i Statistik: \n" +
  "\t Shift + S + H : Hent Statistik: \n" +
  "\t Shift + S + E : Eksporter Statistik: \n" +
  "  Alt + Shift + D : Gå til Døråbner: \n" +
  "  Alt + Shift + A : Gå til SMS Alarmer: \n" +
  "  Alt + Shift + K : Gå til Kundeadministration  \n" +
  "  Alt + Shift + O : Åben menu "
  return listOfActions.split('\n')
}

export const ShortcutKeys: FC<Props> = ({ }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const divRef = React.useRef(null);

    const handleShortcutOpen = () => { // opens the shortcut list
        setOpen(true)
      };
      
      const handleShortcutClose = () => { //closes the shortcut list and clears AnchorE1
        setOpen(false)
        setAnchorEl(null)
      };

    return(
      <>
      <ListItem  onClick={handleShortcutOpen} style={{marginTop: "30px"}}>
          <ListItemIcon>
              <SvgIcon><CompareArrowsIcon/></SvgIcon>
          </ListItemIcon>
          <ListItemText primary={<b> Genvejstaster </b>} />
      </ListItem>

        <Dialog open={open} onClick={() => handleShortcutClose()} aria-labelledby="loading-symbol" aria-describedby="loading-des" >
        <DialogTitle id="alert-dialog-title">{"Genvejstaster i Webportalen"}</DialogTitle>
        <DialogContent style={{display: "flex", alignContent: "center", alignSelf: "center", alignItems: "center"}}>
          <DialogContentText id="alert-dialog-description" > 
            <List className={classes.listItems}>
          {helpText().map((str: string, index) => (
                      <ListItem key={index} alignItems="flex-start">
                        <ListItemText primary={str}/>
                        </ListItem>   
                     ))}   
            </List>
          </DialogContentText>   
        </DialogContent>
        </Dialog>     
      </> 
    )
  }